import httpClient from '@/services/httpClient'
import {
  ICreatePatientRegistration,
  IHealthPlanList,
  IPreRegistration,
  IResponsePreRegistrationData,
  IRegistrationHolder,
  IValidateCode,
  IResponseVerifyCpf,
  IVerifyElegibility,
  IValidateHealthPlan,
  IGetHealthPlanList,
} from './patient-registration-types'
import qs from 'qs'

export default {
  async verifyPatientCpf(
    cpf: string,
    captchToken: string,
  ): Promise<IResponseVerifyCpf> {
    const { data } = await httpClient.post(
      `integration/app-paciente/cadastro-paciente/verifica-contas-por-cpf`,
      { cpf },
      { headers: { captcha: captchToken } },
    )
    return data.object
  },

  async createPreRegistration(
    params: IPreRegistration,
  ): Promise<IResponsePreRegistrationData> {
    const { data } = await httpClient.post(
      `/integration/app-paciente/cadastro-paciente/pre-cadastro`,
      params,
    )
    return data.object
  },

  async validateCode(params: IValidateCode): Promise<boolean> {
    const { data } = await httpClient.post(
      `/integration/app-paciente/cadastro-paciente/confirmar-codigo`,
      params,
    )
    return data.object
  },

  async createPatientRegistration(
    params: ICreatePatientRegistration,
  ): Promise<void> {
    const { data } = await httpClient.post(
      `/integration/app-paciente/cadastro-paciente`,
      params,
    )
    return data.object
  },

  async validateHealthPlan(params: IValidateHealthPlan): Promise<boolean> {
    const { data } = await httpClient.post(
      '/integration/app-paciente/cadastro-paciente/valida-prosseguimento-cadastro',

      params,
    )

    return data.object
  },

  async getRegistrationHolder(
    idClinic: number,
    cpf: string,
  ): Promise<IRegistrationHolder> {
    const { data } = await httpClient.get(
      `/integration/app-paciente/cadastro-paciente/validar-titular-cadastrado/${idClinic}/${cpf}`,
    )
    return data.object
  },

  async getHealthPlanList(
    queryParams: IGetHealthPlanList,
  ): Promise<IHealthPlanList[]> {
    const { data } = await httpClient.get(
      `/integration/app-paciente/cadastro-paciente/listar-planos-disponiveis`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      },
    )
    return data.object
  },

  async getAllHealthPlanList(
    queryParams: IGetHealthPlanList,
  ): Promise<IHealthPlanList[]> {
    const { data } = await httpClient.get(
      `https://hml-api.conexasaude.com.br/integration/app-paciente/cadastro-paciente/listar-operadoras`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
      },
    )
    return data.object
  },

  async createHealthPlan(name: string): Promise<void> {
    const { data } = await httpClient.post(
      `/integration/app-paciente/cadastro-paciente/inserir-plano-sem-contrato`,
      { nome: name },
    )
    return data.object
  },

  async getAcceptTerm(idClinic: number): Promise<string> {
    const { data } = await httpClient.get(
      `/integration/app-paciente/cadastro-paciente/obter-termo/${idClinic}`,
    )
    return data.object
  },

  async getVerifyEligibility(params: IVerifyElegibility): Promise<void> {
    const { data } = await httpClient.post(
      `integration/app-paciente/cadastro-paciente/verifica-elegibilidade`,
      params,
    )
    return data.object
  },
}
